import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import AuditTable from 'containers/tables/AuditTable';
import { fetchEntityAuditLogs } from 'services/audits/duck';

const AuditViewContainer = (props) => {
    const { entityId, audits, dispatch } = props;
    useEffect(() => {
        dispatch(fetchEntityAuditLogs({ entityId }));
    }, [entityId]);

    return (audits.revisions && audits.revisions.length) ? <AuditTable data={audits.revisions} /> : 'No Revision History';
};

const mapStateToProps = state => ({
    audits: state.audits,
});

export default connect(mapStateToProps)(AuditViewContainer);



// WEBPACK FOOTER //
// ./src/containers/AuditViewContainer.js